// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zxLT","top":"styles_top__3p2jy"};